export default __webpack_public_path__ + "static/media/english-to-french-screenshot-02.827c13ad.png";